export default "__VITE_ASSET__C$2s$2h0__"